<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="审核类型" prop="type">
                <a-select style="width: 100%" v-model="queryParam.type" placeholder="请选择审核类型" allow-clear>
                  <a-select-option v-for="(item, index) in this.customDict.RelatedAuditTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="nickName">
                <a-input v-model="queryParam.nickName" placeholder="请输入用户名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="审核方式" prop="auditWay">
                <a-select v-model="queryParam.auditWay" placeholder="请选择审核方式" allow-clear>
                  <a-select-option :value="1">自动审核</a-select-option>
                  <a-select-option :value="2">手动审核</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="status">
                <a-select style="width: 100%" v-model="queryParam.status" placeholder="请选择审核状态" allow-clear>
                  <a-select-option v-for="(item, index) in this.customDict.RelatedAuditStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--            <template v-if="advanced">-->
            <!--            </template>-->
            <a-col :md="24" :sm="24">
              <!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:related/audit/record:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:related/audit/record:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:related/audit/record:remove']">-->
        <!--          <a-icon type="delete" />删除-->
        <!--        </a-button>-->
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:related/audit/record:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="image" slot-scope="text, record">
          <template v-if="record.image != null">
            <img
              v-for="imgUrl in record.image.split(',')"
              :src="imgUrl"
              style="width: 60px; height: 60px; cursor: pointer"
              preview
              alt=""
            />
          </template>
        </span>
        <span slot="video" slot-scope="text, record">
          <video
            v-if="record.video != null"
            controls
            style="width: 100%; cursor: pointer"
            :src="record.video"
          >
            您的浏览器不支持视频播放
          </video>
        </span>
        <span slot="auditWay" slot-scope="text, record">
          <custom-dict-tag :options="customDict.RelatedAuditStatusEnum" :value="record.auditWay" />
        </span>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.RelatedAuditStatusEnum" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="auditTime" slot-scope="text, record">
          {{ parseTime(record.auditTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!--          <a-divider type="vertical" v-hasPermi="['user:related/audit/record:edit']" />-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:related/audit/record:edit']">
            <a-icon type="edit" />修改
          </a>
          <!--          <a-divider type="vertical" v-hasPermi="['user:related/audit/record:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['user:related/audit/record:remove']">-->
          <!--            <a-icon type="delete" />删除-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listRelatedAuditRecord, delRelatedAuditRecord } from '@/api/user/relatedAuditRecord'
import CreateForm from './modules/CreateForm'
import CustomDictTag from '@/components/DictCustomTag'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'RelatedAuditRecord',
  components: {
    CreateForm,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: undefined,
        userId: undefined,
        nickName: undefined,
        content: undefined,
        relationId: undefined,
        image: undefined,
        auditWay: undefined,
        status: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '审核类型 1.剧评审核 2.上车认证',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '审核类型',
          dataIndex: 'typeName',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '二级类型',
          dataIndex: 'subTypeName',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        // {
        //   title: '用户id',
        //   dataIndex: 'userId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '用户名称',
          dataIndex: 'nickName',
          width: 120,
          ellipsis: true
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          width: 120,
          ellipsis: true
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true
          // customRender: (text, record) => {
          //   if (record.type === 1) {
          //     return record.evaluationContent
          //   } else {
          //     return text
          //   }
          // },
        },
        // {
        //   title: '关系id',
        //   dataIndex: 'relationId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '图片',
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '视频',
          dataIndex: 'video',
          scopedSlots: { customRender: 'video' },
          width: 110,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核方式',
          dataIndex: 'auditWay',
          width: 80,
          ellipsis: true,
          customRender: (text) => {
            return { '1': '自动', '2': '手动' }[text]
          },
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核时间',
          dataIndex: 'auditTime',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 80,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: { ...mapGetters(['customDict']) },
  watch: {
  },
  methods: {
    /** 查询用户相关审核记录列表 */
    getList () {
      const that = this
      this.loading = true
      listRelatedAuditRecord(this.queryParam).then(response => {
        that.list = response.data.records
        that.total = response.data.total
        that.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        userId: undefined,
        nickName: undefined,
        content: undefined,
        relationId: undefined,
        img: undefined,
        status: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delRelatedAuditRecord(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/related/audit/record/export', {
            ...that.queryParam
          }, `related/audit/record_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style scoped>
/* 容器基础样式 */
.ant-table-row-cell-ellipsis span {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
  max-width: 192px; /* (60px + 2px) * 3 */
}

/* 图片统一样式 */
.ant-table-row-cell-ellipsis img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  cursor: pointer;
  flex: 0 0 calc(33.333% - 2px); /* 三列布局扣除间隙 */
  margin: 0;
  box-sizing: border-box;
}
</style>
